// extracted by mini-css-extract-plugin
export default {"appLogo":"logo_appLogo__UMv8G","App-logo-spin":"logo_App-logo-spin__NJPkm"};